module.exports = __webpack_public_path__ + "img/Mask-group.da724fca.jpg";